import { render, staticRenderFns } from "./NsAddressVn.vue?vue&type=template&id=64c06153&"
import script from "./NsAddressVn.vue?vue&type=script&lang=js&"
export * from "./NsAddressVn.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressVn.vue?vue&type=style&index=0&lang=scss&module=%24x&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports